<div appEventTracking>
    <div class="toast-container">
        <!-- <app-toast aria-live="polite" aria-atomic="true"></app-toast> -->
    </div>
    <app-header></app-header>
    <app-loader></app-loader>
    <app-dialog></app-dialog>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>
